'use strict';
module.exports = typeof __webpack_require__ !== 'undefined' ? __webpack_require__ : eval('require');